import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';
import { commodities } from '../../../../constants/commodities';

export const useGetProducts = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getProducts = useCallback(async (id) => {
    const url = `/exchange-products/${id}?commodity=${Object.keys(commodities)}&prices=true`;
    await get(url);
  }, [get]);

  return { getProducts, data, error, loading };
};


export const useGetNotification = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getNotification = useCallback(async (id) => {
    const url = `/price-alerts/${id}`;
    await get(url);
  }, [get]);

  return { getNotification, data, error, loading };
};

export const usePostNotification = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postNotification = useCallback(async (body) => {
    const url = `/price-alerts`;
    await post(url, body);
  }, [post]);

  return { postNotification, data, error, loading };
};

export const usePutNotification = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putNotification = useCallback(async (id, body) => {
    const url = `/price-alerts/${id}`;
    await put(url, body);
  }, [put]);

  return { putNotification, data, error, loading };
};

export const useDeleteNotification = () => {
  const { deleted, data, error, loading } = useApiHook(true);

  const deleteNotification = useCallback(async (id) => {
    const url = `/price-alerts/${id}`;
    await deleted(url);
  }, [deleted]);

  return { deleteNotification, data, error, loading };
};
